<pda-header></pda-header>
<ng-content></ng-content>
<pda-footer></pda-footer>
<pda-toast aria-live="polite" aria-atomic="true"></pda-toast>